// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_PastaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /rede/pasta — grava (ou apaga, vazio) o link da pasta da unidade no Drive (Full). */
import { registerContract } from './validate'

export interface Rede_PastaInput {
franquia_id?: number
url?: string
}

registerContract('Rede_PastaInput', {
  franquia_id: { type: 'number',  required: false },
  url:         { type: 'string',  required: false },
})
